import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'filterbyskills' })
export class TrainersSkillsPipe implements PipeTransform {
    transform(trainersList: any[], search: string): any[] {
        if (trainersList === undefined || search === '') {
            return trainersList;
        }
        trainersList.map((trainer) => (trainer.selected = false));
        trainersList.sort((trainerA, trainerB) => {
            if (trainerA.trainer.companyName > trainerB.trainer.companyName) {
                return 1;
            } else if (
                trainerA.trainer.companyName < trainerB.trainer.companyName
            ) {
                return -1;
            } else {
                return 0;
            }
        });
        return trainersList.filter((trainer) => {
            trainer.filteredSkills = trainer.trainer.trainerSkills.filter(
                (training) => {
                    let splitSearch = search.split(' ');
                    for (let i = 0; i < splitSearch.length; i++) {
                        if (i > 0 && splitSearch[i] === '') {
                            break;
                        }
                        let pattern = '(^' + splitSearch[i] + '.*)';
                        if (
                            training.trainingName.match(
                                new RegExp(pattern, 'i')
                            )
                        ) {
                            return true;
                        }
                    }
                }
            );
            if (trainer.filteredSkills.length > 0) {
                return true;
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/_shared/trainers-skills.pipe.ts